function getRunBatchId(run) {
  if (!run) {
    return null;
  }

  const nestedBatchId = run.batch?.id;
  if (nestedBatchId != null && nestedBatchId !== '') {
    return nestedBatchId;
  }

  if (run.batch_id != null && run.batch_id !== '') {
    return run.batch_id;
  }

  if (
    run.batch != null &&
    (typeof run.batch === 'string' || typeof run.batch === 'number')
  ) {
    return run.batch;
  }

  return null;
}

export function getBatchRunWorkspacePath(run) {
  const batchId = getRunBatchId(run);
  const runId = run?.id;

  if (batchId == null || batchId === '' || runId == null || runId === '') {
    return null;
  }

  const params = new URLSearchParams();
  params.set('batchId', String(batchId));
  params.set('focusRun', String(runId));
  return `/workflow/batches?${params.toString()}`;
}

export function canOpenRunInBatchWorkspace(run) {
  return Boolean(getBatchRunWorkspacePath(run));
}
